import React from "react";
import "./../../assets/css/NmsIntervention/NmsIntervention.scss";
import "./../../assets/css/ClinicalChecks.scss";
import { Skeleton } from "@mui/material";
import useTitanApp from "../../hooks/useTitanApp";

export default function LoadingComponentNMSTimeline() {
  const { appState } = useTitanApp();
  const { darkMode } = appState;
  return (
    <div className="loading-card-one">
      <Skeleton
        sx={{ bgcolor: darkMode ? "grey.800" : "" }}
        height={35}
        animation="wave"
        variant="rounded"
      />
      <Skeleton
        sx={{ bgcolor: darkMode ? "grey.800" : "" }}
        height={35}
        animation="wave"
        variant="rounded"
      />
      <Skeleton
        sx={{ bgcolor: darkMode ? "grey.800" : "" }}
        height={35}
        animation="wave"
        variant="rounded"
      />
      <Skeleton
        sx={{ bgcolor: darkMode ? "grey.800" : "" }}
        height={35}
        animation="wave"
        variant="rounded"
      />
      <Skeleton
        sx={{ bgcolor: darkMode ? "grey.800" : "" }}
        height={35}
        animation="wave"
        variant="rounded"
      />
      <Skeleton
        sx={{ bgcolor: darkMode ? "grey.800" : "" }}
        height={35}
        animation="wave"
        variant="rounded"
      />
      <Skeleton
        sx={{ bgcolor: darkMode ? "grey.800" : "" }}
        height={35}
        animation="wave"
        variant="rounded"
      />
      <Skeleton
        sx={{ bgcolor: darkMode ? "grey.800" : "" }}
        height={35}
        animation="wave"
        variant="rounded"
      />
      <Skeleton
        sx={{ bgcolor: darkMode ? "grey.800" : "" }}
        height={35}
        animation="wave"
        variant="rounded"
      />
      <Skeleton
        sx={{ bgcolor: darkMode ? "grey.800" : "" }}
        height={35}
        animation="wave"
        variant="rounded"
      />
      <Skeleton
        sx={{ bgcolor: darkMode ? "grey.800" : "" }}
        height={35}
        animation="wave"
        variant="rounded"
      />
      <Skeleton
        sx={{ bgcolor: darkMode ? "grey.800" : "" }}
        height={35}
        animation="wave"
        variant="rounded"
      />
    </div>
  );
}
